export default __webpack_public_path__ + "static/media/sepandlogo.85afca36.png";